import React from 'react';
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
  Alert,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import moment from 'moment';

const EvidenceWindowSelector = ({
  formData,
  errors,
  audit_end_date,
  creating,
  handleChange,
  handleEvidenceWindowChange,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          mb: 1.5,
          color: theme.customColors.text.strong,
        }}
      >
        Audit Period *
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          mb: 2,
          color: theme.customColors.text.secondary,
        }}
      >
        Select the duration for audit period or choose a custom end date
      </Typography>
      <ToggleButtonGroup
        value={formData.audit_window_months}
        exclusive
        onChange={handleEvidenceWindowChange}
        aria-label="audit period"
        fullWidth
        size="small"
        sx={{
          mb: 2,
          "& .MuiToggleButton-root": {
            py: 1,
            textTransform: "none",
            fontWeight: 500,
            borderColor: theme.customColors.border.main,
            color: theme.customColors.text.strong,
            "&.Mui-selected": {
              backgroundColor: theme.customColors.button.hover,
              color: theme.customColors.button.text,
              "&:hover": {
                backgroundColor: theme.customColors.button.primary,
              },
            },
          },
        }}
      >
        <ToggleButton value="12">12 months</ToggleButton>
        <ToggleButton value="6">6 months</ToggleButton>
        <ToggleButton value="3">3 months</ToggleButton>
        <ToggleButton value="custom">Custom</ToggleButton>
      </ToggleButtonGroup>

      {formData.audit_window_months !== "custom" && audit_end_date && (
        <Alert severity="info" sx={{ mt: 1 }}>
          Audit period will end on: {moment(audit_end_date).format("MMM DD, YYYY")}
        </Alert>
      )}
    </Box>
  );
};

export default EvidenceWindowSelector;
